import { render, staticRenderFns } from "./CategoryFaq.vue?vue&type=template&id=7e27333b&scoped=true&"
import script from "./CategoryFaq.vue?vue&type=script&lang=js&"
export * from "./CategoryFaq.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFaq.vue?vue&type=style&index=0&id=7e27333b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e27333b",
  null
  
)

export default component.exports